import React from 'react';
import { DestinationStatus } from 'modules/dataSync/types';
import { mapStatusToBadge } from 'modules/dataSync/utils';
import { BaseCellWrapper } from './BaseCell';
import { useDataSyncTranslations } from 'modules/dataSync/hooks/useDataSyncTranslations';

interface StatusBadgeProps {
  status: DestinationStatus;
}

export const StatusBadge: React.FC<StatusBadgeProps> = React.memo(({ status }) => {
  const { t } = useDataSyncTranslations();

  const badgeContent = status ? mapStatusToBadge(status) : t('common.na');

  return (
    <BaseCellWrapper dataTestId="status-badge">
      <div
        role="status"
        aria-label={status ? `Destination status: ${status}` : 'Status not available'}
      >
        {badgeContent}
      </div>
    </BaseCellWrapper>
  );
});
